module.exports = "/_next/static/images/6a978f7f9f229f859cf8b590ab043e06-woman-using-cellphone@3x.jpg";